import { CommonRouter } from '@primeit/components-vue';

CommonRouter.registerRoutes([
  {
    component: () => import(/* webpackChunkName: "app.login" */ './SignIn'),
    meta: {
      icon: 'login',
      label: 'appointment',
      order: 0,
      visible: false,
    },
    path: '/login',
  },
]);
